// extracted by mini-css-extract-plugin
module.exports = {"tag":"Tag_tag__Yr0s3","secondary":"Tag_secondary__aaHmN"};